<template>
  <div class="tab-pane fade  active show" id="car-recognition" role="tabpanel" aria-labelledby="car-recognition-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-3">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-select form-select" v-model.number="selectScenicAreaId">
            <option value="">請選擇</option>
            <option value="-1">全部</option>
            <option v-for="(list, index) in carFlowScenicArea" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="inputPassword4" class="form-label">設備地點</label>
          <select class="form-select form-select" v-model="selectDevice">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in ScenicAreaCCTVList" :key="index" :value="list">{{ list.publicPlaceName }}</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="inputPassword4" class="form-label">車種</label>
          <select class="form-select form-select" v-model="selectCarType">
            <option value="">請選擇</option>
            <option v-for="(list, index) in carTypeList" :key="index" :value="list.enumType">{{ list.description }}
            </option>
          </select>
        </div>
      </form>
      <form class="row g-3" style="padding-top: 10px;">
        <div class="col-md-3">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>
        <div class="col-md-3">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk" :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="exportDayCSV" :disabled="isWaitCCTVList"> 
            <i class="fas fa-share"></i> 匯出
          </button>
      </div>
      </form>

      <h1 style="margin-top: 0px;">即時_進出車輛辨識紀錄</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="carRecognition" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">平假日</th>
                    <th scope="col">風景區</th>
                    <th scope="col">設備地點</th>
                    <th scope="col">車種</th>
                    <th scope="col">推估人流</th>
                    <th scope="col">車牌</th>
                    <th scope="col" v-show ="!isShortView">辨識紀錄</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in vehiclePlateList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td>{{ getTime(item) }}</td>
                    <td>{{ item._source.dayType }}</td>
                    <td>{{ item._source.ScenicAreaName }}</td>
                    <!-- <td>{{ getCCTVInOut(item) }}</td> -->
                    <td>{{ getCCTVInOut(item) }}</td>

                    <td>{{ Const.ELK_CAR_TYPE[item._source.ObjectType] }}</td>
                    <!-- <td>{{ item._source.StreamID }}</td> -->

                    <td>{{ item._source.weight }}</td>
                    <td>{{ item._source.licence_plate }}
                      <div v-show ="isShortView">
                        <a class=" px-1 mx-1mt-1" :href="getElkImgHypeLink(item)" target="_blank">
                        <div class="btn-search text-primary">
                          <i class="fas fa-search"></i> 
                          <!-- <p class="mb-0 btn-text">查看</p> -->
                        </div> 

                        </a>
                      </div>
                    </td>        
                    <td v-show ="!isShortView">
                      <a :href="getElkImgHypeLink(item)" target="_blank">
                        <img :src='getElkImgUrl(item)' style="width:100%">
                        <!-- <img src='../../assets/img/test.jpg' style="width:100%"> -->

                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

    </div>

    <dialog-modal ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="123" :modalSize="'xl'"
      :isImage="true" :isMarginAuto="true">
      <div class="object-detection-detail" v-if="ratioData != null">
        <!-- using v-if for avoid to canvas is not defined -->
        <div class="border-bottom pb-1">
          <img :src='ratioData.image.src' :width="ratioData.image.width" :height="ratioData.image.height">
        </div>
      </div>
    </dialog-modal>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import { getCountPerHour } from '../../api/elasticSearch/vehicleplateApi'
import exportCSV from '../../utils/exportCSV'
import DialogModal from '../../components/DialogModal.vue'



export default {
  name: "Home",
  data() {
    return {
      Const: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      vehiclePlateList: [],
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: "",
      selectDevice: "-1",
      carTypeList: CONST.ELK_CAR_TYPE_ENUM,
      selectCarType: '',
      selectItem: null,
      ratioData: null,
      isWaitCCTVList: false,
      viewPort:window.innerWidth,
      isShortView:false,

      maxSelectTime: moment().startOf('m').toISOString(),
    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    ...mapGetters({ ScenicAreaCCTVList: 'getScenicAreaVehicleVideoCamera' }),
    ...mapState("passengerEstimateSetting", { estimateDataList: "allEstimateData" }),
    ...mapGetters("scenicArea", { myscenicAreaList: "getMyScenicArea" }),

    carFlowScenicArea() {
      return this.myscenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    },
 
  },
  watch: {
    viewPort:{
      handler(newVal){
        // console.log("newVal",newVal);
        // console.log("this.isShortView",this.isShortView);
        if(newVal < 500){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    
    },
    

    async selectScenicAreaId() {
      this.isWaitCCTVList = true
      if(this.selectScenicAreaId === -1) {
        const myScenicAreaId = await this.carFlowScenicArea.map(s => s.id);
        // console.log("myScenicAreaId",myScenicAreaId)
        await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: myScenicAreaId })
      }else {
        await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      }
      // await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      
      this.selectDevice = "-1"
      this.isWaitCCTVList = false 
    },
  },
  methods: {
    getElkImgHypeLink(item) {
      return Utils.transElkImgHyperLink(item._source.Url) 
    },
    getElkImgUrl(item) {
      return Utils.transElkImgByNginx(item._source.Url)
    },

    selectImg(item) {
      this.$refs.objectDetectionDetail.openModal()
      this.selectItem = item
      this.imgZoom()
    },

    imgZoom() {
      const img = new Image()
      img.src = this.getElkImgUrl(this.selectItem)
      img.width = CONST.IMG_MAX_WIDTH
      img.height = CONST.IMG_MAX_HEIGHT

      if (img.width > CONST.IMG_MAX_WIDTH || img.height > CONST.IMG_MAX_HEIGHT) {
        this.ratioData = this.imgZoomIn(img)
      } else {
        this.ratioData = {
          image: img
        }
      }
    },

    imgZoomIn(img) {
      let ratioWidth = 1
      let ratioHeight = 1
      const currentImgWidth = img.width
      let currentImgHeight = img.height
      let bRatioWidth = false

      if (currentImgWidth > CONST.IMG_MAX_WIDTH) {
        ratioWidth = CONST.IMG_MAX_WIDTH / currentImgWidtho
        currentImgHeight = currentImgHeight * ratioWidth
        img.width = CONST.IMG_MAX_WIDTH
        img.height = currentImgHeight
        bRatioWidth = true
      }

      if (currentImgHeight > CONST.IMG_MAX_HEIGHT) {
        ratioHeight = CONST.IMG_MAX_HEIGHT / currentImgHeight
        img.height = CONST.IMG_MAX_HEIGHT
        if (bRatioWidth) {
          img.width = CONST.IMG_MAX_WIDTH * ratioHeight
        } else {
          img.width = currentImgWidth * ratioHeight
        }
      }

      return {
        image: img,
      }
    },
    
    genDayCSVContent(vehiclePlateList) {
      const csvContent = [['時間', '平假日', '風景區', '設備名稱','車種', '推估人流', '車牌']]

      vehiclePlateList.forEach(item => {
        const row = []
        row.push(this.getTime(item))
        row.push(item._source.dayType)
        row.push(item._source.ScenicAreaName)
        row.push(this.getCCTVInOut(item))
        row.push(CONST.ELK_CAR_TYPE[item._source.ObjectType])
        row.push(item._source.weight)
        row.push(item._source.licence_plate)

        csvContent.push(row)
      })

      return csvContent
    },

    async exportDayCSV() {
      await this.searchELK()
      const vehiclePlateList = this.$store.getters['vehiclePlate/getVehiclePlateSearchData']
      Utils.setVehicleStreamName(vehiclePlateList, true)


      const csvContent = this.genDayCSVContent(vehiclePlateList)
      const fileName = `即時_進出車輛辨識紀錄${moment(this.startTime).format('YYYY/MM/DD HH:mm')}.csv`
      exportCSV.genCSVFile(csvContent, fileName)
    },

    async queryElk() {
      await this.searchELK()

      this.vehiclePlateList = this.$store.getters['vehiclePlate/getVehiclePlateSearchData']
      console.log('this.vehiclePlateList', this.vehiclePlateList);
      Utils.setVehicleStreamName(this.vehiclePlateList, true)
      this.updateTable()
    },

    async searchELK() {
      if(this.selectScenicAreaId === ""){
        alert('請選擇風景區')
        return
      }

      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return
      }

      const condition = {
        // streamIds:  ['0462734d-018f-4f2d-8f4f-d80d4489100f'],
        streamIds: [],
        objectTypes: [],
        keyword: ''
      }

      if (this.selectScenicAreaId > -1 && this.ScenicAreaCCTVList.length === 0) {
        // 只選風景區但此風景區沒有設備
        condition.streamIds.push(null)

      } else if(this.selectScenicAreaId == -1 ){
        
        // console.log("list",this.ScenicAreaCCTVList)
        this.ScenicAreaCCTVList.forEach(element => {
          condition.streamIds.push(element.streamId)
        })
        // console.log("condition",condition)
      }else if (this.selectScenicAreaId > -1 && this.selectDevice === "-1") {
        // 只選風景區，查詢所有景區設備
        this.ScenicAreaCCTVList.forEach(element => {
          condition.streamIds.push(element.streamId)
        })

        // if(this.selectScenicAreaId === 12) {
        //   condition.streamIds.push('cd401787-7109-4fb8-a709-30270efbc9a2') // 芭崎出口現在是用入口的辨識串流
        // }

      } else if (this.selectScenicAreaId > -1) {
        // 只查選擇的設備
        console.log('this.selectDevice', this.selectDevice)
    
        condition.streamIds.push(this.selectDevice.streamId)
        
        
      }


      if (!Utils.isEmptyString(this.selectCarType)) {
        condition.objectTypes.push(this.selectCarType)
      }

      condition.unit = 'd'
      condition.value = -1
      condition.startTime = moment(this.startTime).startOf('minute').format()
      condition.endTime = moment(this.endTime).startOf('minute').format()
      await this.$store.dispatch('vehiclePlate/updateVehiclePlateSearchData', condition)
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item._source.OccurrenceTime)) {
        return '-'
      }

      return moment(item._source.OccurrenceTime).format('YYYY/MM/DD HH:mm')
    },

    updateMaxSelectTime() {
      this.maxSelectTime = moment().startOf('m').toISOString(); // 更新為當前時間
    },

    getCCTVInOut(data){
      Utils.setVehicleStreamName(data, true);
      
      console.log("data",data);
      // return data._source.StreamName;
      return data._source.PublicPlaceName;


    },

    initTable: function () {
      this.table = $("#carRecognition").DataTable({
        aoColumns: [
          ...new Array($("#carRecognition th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 25
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable();
    // this.viewPort = window.innerWidth;
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
  };
  window.addEventListener('resize', this.$_resizeEventHandler);
  },

  beforeDestroy() {
  window.removeEventListener('resize', this.$_resizeEventHandler);
},
  components: { DialogModal }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */


.btn-search{
  width:20px;
  height: 20px;
  margin: 0 auto;
}
</style>
